import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{attrs:{"outlined":"","label":_vm.label,"validate-on-blur":"","disabled":_vm.disabled,"readonly":_vm.readOnly ? _vm.readOnly : false,"rules":[_vm.checkRequired(), _vm.validateEmail()]},model:{value:(_vm.emailAddressValue),callback:function ($$v) {_vm.emailAddressValue=$$v},expression:"emailAddressValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }